module.exports = __webpack_public_path__ + "img/DontBeLikeRickFreeWifi.bea78533.jpg";